import { getCookie } from "@insite/client-framework/Common/Cookies";
import mergeToNew from "@insite/client-framework/Common/mergeToNew";
import { emptyGuid } from "@insite/client-framework/Common/StringHelpers";
import StyledWrapper from "@insite/client-framework/Common/StyledWrapper";
import { Dictionary } from "@insite/client-framework/Common/Types";
import { setMainNavigation } from "@insite/client-framework/Components/ShellHoleConnect";
import Logger from "@insite/client-framework/Logger";
import ApplicationState from "@insite/client-framework/Store/ApplicationState";
import { getSession, getSettingsCollection } from "@insite/client-framework/Store/Context/ContextSelectors";
import {
    getCategoriesDataView,
    getCategoryDepthLoaded,
    getCategoryState,
    getSubCategoryIds,
} from "@insite/client-framework/Store/Data/Categories/CategoriesSelectors";
import loadCategories from "@insite/client-framework/Store/Data/Categories/Handlers/LoadCategories";
import loadCategory from "@insite/client-framework/Store/Data/Categories/Handlers/LoadCategory";
import { getPageLinkByNodeId, getPageLinkByPageType } from "@insite/client-framework/Store/Links/LinksSelectors";
import translate from "@insite/client-framework/Translate";
import { HasFields } from "@insite/client-framework/Types/ContentItemModel";
import { LinkFieldValue } from "@insite/client-framework/Types/FieldDefinition";
import WidgetModule from "@insite/client-framework/Types/WidgetModule";
import WidgetProps from "@insite/client-framework/Types/WidgetProps";
import { StylesContext } from "@insite/content-library/additionalStyles";
import NavigationDrawer from "@thkStore/Overrides/Components/NavigationDrawer";
import { NavigationModeCookieName } from "@insite/content-library/Components/NavigationModeMenu";
import SearchInput, { SearchInputStyles } from "@insite/content-library/Widgets/Header/SearchInput";
import Button, { ButtonIcon, ButtonPresentationProps } from "@insite/mobius/Button";
import { GridContainerProps } from "@insite/mobius/GridContainer";
import { GridItemProps } from "@insite/mobius/GridItem";
import Hidden from "@insite/mobius/Hidden";
import { IconProps } from "@insite/mobius/Icon";
import Search from "@insite/mobius/Icons/Search";
import X from "@insite/mobius/Icons/X";
import Link, { LinkPresentationProps } from "@insite/mobius/Link";
import { MenuPresentationProps } from "@insite/mobius/Menu";
import Modal, { ModalPresentationProps } from "@insite/mobius/Modal";
import { PopoverPresentationProps, PositionStyle } from "@insite/mobius/Popover";
import { TypographyPresentationProps } from "@insite/mobius/Typography";
import { resolveColor } from "@insite/mobius/utilities";
import getColor from "@insite/mobius/utilities/getColor";
import InjectableCss from "@insite/mobius/utilities/InjectableCss";
import VisuallyHidden from "@insite/mobius/VisuallyHidden";
// eslint-disable-next-line spire/fenced-imports
import { TS } from "@insite/shell/TS";
import { MAIN_NAVIGATION_DESTINATION_TYPE, MAIN_NAVIGATION_LINK_TYPE } from "@thkStore/Common/Constants";
import {
    DEFAULT_FOOTNOTE_LINE_1 as DEFAULT_TECH_SUPPORT_FOOTNOTE_1,
    DEFAULT_FOOTNOTE_LINE_2 as DEFAULT_TECH_SUPPORT_FOOTNOTE_2,
    DEFAULT_LINKS as DEFAULT_TECH_SUPPORT_LINKS,
    DEFAULT_MEMBERSHIP_CHECK_TEXT as DEFAULT_TECH_SUPPORT_MEMBERSHIP_CHECK_TEXT,
    DEFAULT_MEMBERSHIP_CHECK_URL as DEFAULT_TECH_SUPPORT_MEMBERSHIP_CHECK_URL,
    DEFAULT_MEMBER_BUTTON_TEXT as DEFAULT_TECH_SUPPORT_BUTTON_TEXT,
    DEFAULT_MEMBER_REGISTRATION_URL as DEFAULT_TECH_SUPPORT_REGISTRATION_URL,
    DEFAULT_SECTION_TITLE as DEFAULT_TECH_SUPPORT_TITLE,
    LinkItem as TechSupportLinkItem,
} from "@thkStore/Components/TechnicalSupportToolsContent";
import MainNavigationItem from "@thkStore/Overrides/Components/MainNavigationItem";

import * as cssLinter from "css";
import isEqual from "lodash/isEqual";
import * as React from "react";
import { connect, ResolveThunks } from "react-redux";
import { css } from "styled-components";

const enum fields {
    links = "links",
    showQuickOrder = "showQuickOrder",
    openParentPages = "openParentPages",
    customCSS = "customCSS",
    technicalSupportTitle = "technicalSupportTitle",
    technicalSupportLinks = "technicalSupportLinks",
    technicalSupportFootnote1 = "technicalSupportFootnote1",
    technicalSupportFootnote2 = "technicalSupportFootnote2",
    technicalSupportButtonText = "technicalSupportButtonText",
    technicalSupportRegistrationUrl = "technicalSupportRegistrationUrl",
    technicalSupportMembershipCheckText = "technicalSupportMembershipCheckText",
    technicalSupportMembershipCheckUrl = "technicalSupportMembershipCheckUrl",
}

interface OwnProps extends WidgetProps {
    fields: {
        [fields.links]: LinkModel[];
        [fields.showQuickOrder]: boolean;
        [fields.openParentPages]: boolean;
        [fields.customCSS]: string;
        [fields.technicalSupportTitle]: string;
        [fields.technicalSupportLinks]: TechSupportLinkItem[];
        [fields.technicalSupportFootnote1]: string;
        [fields.technicalSupportFootnote2]: string;
        [fields.technicalSupportButtonText]: string;
        [fields.technicalSupportRegistrationUrl]: string;
        [fields.technicalSupportMembershipCheckText]: string;
        [fields.technicalSupportMembershipCheckUrl]: string;
    };
    isCompactHeaderFlyoutMenu: boolean;
    flyoutCustomCSS?: string;
    showFlyoutPricingToggle?: boolean;
    showFlyoutInventoryToggle?: boolean;
    isCompactHeaderMainNavigation: boolean;
    сompactHeaderMainNavigationCustomCSS?: string;
}

interface LinkModel {
    fields: {
        openInNewWindow: boolean;
        destination: LinkFieldValue;
        linkType:
            | MAIN_NAVIGATION_LINK_TYPE.Link
            | MAIN_NAVIGATION_LINK_TYPE.MegaMenu
            | MAIN_NAVIGATION_LINK_TYPE.CascadingMenu
            | MAIN_NAVIGATION_LINK_TYPE.CustomLinkList;
        overrideTitle: string;
        title: string;
        numberOfColumns: number;
        maxDepth: number;
        childLinks?: LinkModel[];
        titleLink?: LinkFieldValue;
        parentTitle?: string;
        excludedCategories?: string[];
    };
}

export interface MappedLink {
    title: string;
    url: string;
    type?: string;
    excludeFromNavigation?: boolean;
    openInNewWindow?: boolean;
    numberOfColumns?: number;
    maxDepth?: number;
    childrenType?:
        | MAIN_NAVIGATION_LINK_TYPE.MegaMenu
        | MAIN_NAVIGATION_LINK_TYPE.CascadingMenu
        | MAIN_NAVIGATION_LINK_TYPE.CustomLinkList;
    children?: MappedLink[];
}

const mapStateToProps = (state: ApplicationState, ownProps: OwnProps) => {
    const {
        fields: { links = [] },
    } = ownProps;
    const mappedLinks = [];
    const categoryIdsToLoad: Dictionary<number> = {};

    for (const link of links) {
        const excludedCategoryIds = link.fields.excludedCategories || [];
        const mappedLink = mapLink(link, state, categoryIdsToLoad, false, excludedCategoryIds);

        if (!mappedLink) {
            continue;
        }

        mappedLinks.push(mappedLink);
    }

    const currentMode = getCookie(NavigationModeCookieName) || "Storefront";
    const orderSettings = getSettingsCollection(state).orderSettings;
    const session = getSession(state);
    const isAuthenticated = session?.isAuthenticated && !session?.isGuest;
    const isVmiAdmin = session.userRoles?.toLowerCase().indexOf("vmi_admin") !== -1;
    const isVmiUser = session.userRoles?.toLowerCase().indexOf("vmi_user") !== -1;

    return {
        links: mappedLinks,
        quickOrderLink: getPageLinkByPageType(state, "QuickOrderPage"),
        categoryIdsToLoad,
        allowQuickOrder: orderSettings.allowQuickOrder,
        categoryErrorStatusCodeById: state.data.categories.errorStatusCodeById,
        categoryIdsCalled: state.data.categories.categoryIdsCalled,
        displayChangeCustomerLink: session?.displayChangeCustomerLink,
        displayVmiNavigation:
            currentMode === "Vmi" && orderSettings.vmiEnabled && isAuthenticated && (isVmiAdmin || isVmiUser),
        displayModeSwitch: isAuthenticated && orderSettings.vmiEnabled && (isVmiAdmin || isVmiUser),
        currentMode,
        vmiPageLinks: isVmiAdmin
            ? [
                  getPageLinkByPageType(state, "VmiDashboardPage"),
                  getPageLinkByPageType(state, "VmiLocationsPage"),
                  getPageLinkByPageType(state, "VmiUsersPage"),
                  getPageLinkByPageType(state, "VmiBinsPage"),
                  getPageLinkByPageType(state, "VmiReportingPage"),
                  getPageLinkByPageType(state, "VmiOrderHistoryPage"),
              ]
            : isVmiUser
              ? [
                    getPageLinkByPageType(state, "VmiDashboardPage"),
                    getPageLinkByPageType(state, "VmiLocationsPage"),
                    getPageLinkByPageType(state, "VmiBinsPage"),
                    getPageLinkByPageType(state, "VmiReportingPage"),
                    getPageLinkByPageType(state, "VmiOrderHistoryPage"),
                ]
              : [],
    };
};

const mapLink = (
    link: LinkModel,
    state: ApplicationState,
    categoryIdsToLoad: Dictionary<number>,
    isChildLink = false,
    excludedCategoryIds: string[] = [],
) => {
    const {
        fields: {
            linkType,
            destination,
            openInNewWindow,
            overrideTitle: overrideTitleValue,
            numberOfColumns,
            maxDepth,
            title: titleValue,
            childLinks,
            parentTitle,
            titleLink,
        },
    } = link;
    const { type: typeValue, value: destinationValue } = destination;

    let type = typeValue;
    let value = destinationValue;
    let title = titleValue;
    let overrideTitle = overrideTitleValue;
    if (linkType === MAIN_NAVIGATION_LINK_TYPE.CustomLinkList) {
        type = titleLink?.type ?? MAIN_NAVIGATION_DESTINATION_TYPE.Page;
        value = titleLink?.value ?? "";
        title = parentTitle ?? "";
        overrideTitle = parentTitle ?? "";
    }

    const depthToLoad =
        linkType === MAIN_NAVIGATION_LINK_TYPE.MegaMenu
            ? 3
            : linkType === MAIN_NAVIGATION_LINK_TYPE.CustomLinkList || isChildLink
              ? 0
              : maxDepth;

    let mappedLink: MappedLink | undefined;

    if (type === MAIN_NAVIGATION_DESTINATION_TYPE.Url) {
        mappedLink = {
            url: value,
            title: isChildLink ? overrideTitle : title,
        };
    } else if (type === MAIN_NAVIGATION_DESTINATION_TYPE.Page) {
        const readonlyPageLink = getPageLinkByNodeId(state, value);
        if (readonlyPageLink) {
            mappedLink = { ...readonlyPageLink };
            if (overrideTitle) {
                mappedLink.title = overrideTitle;
            }
        }
    } else if (type === MAIN_NAVIGATION_DESTINATION_TYPE.Category) {
        mappedLink = setupCategoryLink(
            state,
            value,
            categoryIdsToLoad,
            depthToLoad,
            overrideTitle,
            state.data.categories.categoryIdsCalled,
            excludedCategoryIds,
        );
    }

    if (linkType === MAIN_NAVIGATION_LINK_TYPE.CustomLinkList) {
        if (!mappedLink) {
            mappedLink = {
                title: parentTitle ?? title,
                url: "",
                excludeFromNavigation: false,
                childrenType: MAIN_NAVIGATION_LINK_TYPE.CustomLinkList,
            };
        }
        let mappedChildren: MappedLink[] = [];
        if (childLinks && childLinks.length > 0) {
            for (const child of childLinks) {
                const childLink = mapLink(child, state, categoryIdsToLoad, true);
                if (childLink) {
                    mappedChildren.push(childLink);
                }
            }
        }
        mappedLink.children = mappedChildren;
    }

    if (!mappedLink) {
        return;
    }

    mappedLink.openInNewWindow = openInNewWindow;
    mappedLink.numberOfColumns = numberOfColumns;
    mappedLink.maxDepth = maxDepth;
    mappedLink.excludeFromNavigation =
        linkType === MAIN_NAVIGATION_LINK_TYPE.CustomLinkList || isChildLink ? false : mappedLink.excludeFromNavigation;

    if (
        linkType === MAIN_NAVIGATION_LINK_TYPE.MegaMenu ||
        linkType === MAIN_NAVIGATION_LINK_TYPE.CascadingMenu ||
        linkType === MAIN_NAVIGATION_LINK_TYPE.CustomLinkList
    ) {
        mappedLink.childrenType = linkType;
    }
    return mappedLink;
};

const getParameter = (categoryId: string, maxDepth: number) => ({
    maxDepth,
    startCategoryId: categoryId === emptyGuid ? undefined : categoryId,
    includeStartCategory: categoryId !== emptyGuid,
});

const setupCategoryLink = (
    state: ApplicationState,
    value: string,
    categoryIdsToLoad: Dictionary<number>,
    maxDepth: number,
    overrideTitle: string,
    categoryIdsCalled: string[],
    excludedCategoryIds: string[] = [],
) => {
    let mappedLink: MappedLink | undefined;

    if (!value) {
        return;
    }

    const depthLoaded = getCategoryDepthLoaded(state, value);
    const subCategoryIds = getSubCategoryIds(state, value);
    if (
        (depthLoaded < maxDepth || (!subCategoryIds && !categoryIdsCalled?.includes(value))) &&
        !getCategoriesDataView(state, getParameter(value, maxDepth)).isLoading
    ) {
        categoryIdsToLoad[value] = maxDepth;
    } else {
        if (value === emptyGuid) {
            mappedLink = {
                url: "",
                title: overrideTitle || translate("Products"),
            };
        } else {
            const categoryState = getCategoryState(state, value);
            if (!categoryState.value) {
                if (
                    !categoryState.isLoading &&
                    !getCategoriesDataView(state, getParameter(value, maxDepth)).isLoading
                ) {
                    categoryIdsToLoad[value] = maxDepth;
                }
                return;
            }
            mappedLink = {
                url: categoryState.value.path,
                title: overrideTitle || categoryState.value.shortDescription,
            };
        }

        loadSubCategories(mappedLink, subCategoryIds, 1, maxDepth, state, excludedCategoryIds);
    }

    return mappedLink;
};

const loadSubCategories = (
    mappedLink: MappedLink,
    subCategoryIds: readonly string[] | undefined,
    currentDepth: number,
    maxDepth: number,
    state: ApplicationState,
    excludedCategoryIds: string[] = [],
) => {
    if (currentDepth > maxDepth) {
        return;
    }
    mappedLink.children = [];
    if (!subCategoryIds) {
        return;
    }
    for (const subCategoryId of subCategoryIds) {
        if (excludedCategoryIds.length > 0 && excludedCategoryIds.includes(subCategoryId)) {
            continue;
        }

        const subCategory = getCategoryState(state, subCategoryId).value;
        if (!subCategory) {
            Logger.error(`Category ${subCategoryId} was not found in data state, excluding from navigation.`);
            continue;
        }
        const childLink: MappedLink = {
            url: subCategory.path,
            title: subCategory.shortDescription,
            children: [],
        };
        mappedLink.children.push(childLink);

        loadSubCategories(
            childLink,
            subCategory.subCategoryIds,
            currentDepth + 1,
            maxDepth,
            state,
            excludedCategoryIds,
        );
    }
};

const mapDispatchToProps = {
    loadCategories,
};

type Props = OwnProps & ReturnType<typeof mapStateToProps> & ResolveThunks<typeof mapDispatchToProps>;

interface State {
    selectedLinkIndex?: number;
    mobileSearchModalIsOpen: boolean;
}

export interface MainNavigationStyles {
    menuHeight: number;
    container?: InjectableCss;
    itemWrapper?: InjectableCss;
    quickOrderItemWrapper?: InjectableCss;
    menuItem?: InjectableCss;
    menuItemIcon?: IconProps;
    menuItemTypography?: TypographyPresentationProps;
    cascadingMenu?: MenuPresentationProps;
    megaMenu?: PopoverPresentationProps;
    megaMenuGridContainer?: GridContainerProps;
    megaMenuGridItem?: GridItemProps;
    megaMenuHeading?: LinkPresentationProps;
    megaMenuLink?: LinkPresentationProps;
    mobileWrapper?: InjectableCss;
    compactFlyoutMenu?: InjectableCss;
    mobileMenuWrapper?: InjectableCss;
    mobileSearchButton?: ButtonPresentationProps;
    mobileSearchWrapper?: InjectableCss;
    mobileSearchModal?: ModalPresentationProps;
    mobileSearchInputWrapper?: InjectableCss;
    mobileSearchInputStyles?: SearchInputStyles;
    mobileSearchModalCloseIcon?: IconProps;
}

export const mainNavigationStyles: MainNavigationStyles = {
    menuHeight: 50,
    container: {
        css: css`
            color: ${getColor("common.background")};
            display: flex;
            justify-content: left;
        `,
    },
    itemWrapper: {
        css: css`
            overflow: visible;
            display: flex;

            &:hover {

                nav {

                    & > span, & > a, & > button {

                        &[class^="StyledButton-sc-"] {
                            border-bottom: 5px solid ${({ theme }) => theme.colors.primary.main} !important;

                            & > span {
                                color: ${({ theme }) => theme.colors.primary.main};
                            }
                        }
                    }

                    & > div > .mega-menu > span[class^="StyledButton-sc-"],
                    & > div > .mega-menu > a[class^="StyledButton-sc-"] {
                        border-bottom: 5px solid ${({ theme }) => theme.colors.primary.main};

                        & > span {
                            color: ${({ theme }) => theme.colors.primary.main};
                        }
                    }
                }

                & > a {

                    border-bottom: 5px solid ${({ theme }) => theme.colors.primary.main} !important;

                    & > span {
                        color: ${({ theme }) => theme.colors.primary.main} !important; 
                    }
                }
            }
            
            &:hover span + div {
                display: block;
            }
            
            &:first-child {
                margin-left: -10px;
            }
        `,
    },
    quickOrderItemWrapper: {
        css: css`
            margin-left: auto;
            margin-right: 0;
        `,
    },
    megaMenuGridItem: {
        css: css`
            display: block;
        `,
    },
    megaMenuHeading: {
        css: css`
            font-weight: bold;
            margin-bottom: 8px;
            transition: outline 0.2s ease;

            &:focus,
            &:focus-visible {
                outline: 2px solid ${({ theme }) => theme.colors.primary.main} !important;
                outline-offset: -2px;
            }
        `,
    },
    megaMenuLink: {
        css: css`
            transition:
                outline 0.2s ease,
                color 0.3s ease;

            &:focus,
            &:focus-visible {
                outline: 2px solid ${({ theme }) => theme.colors.primary.main} !important;
                outline-offset: -2px;
            }

            &:hover {
                color: ${({ theme }) => theme.colors.primary.main};
            }
        `,
    },
    menuItem: {
        css: css`
            display: flex;
            align-items: center;
            height: 50px;
            padding: 5px 7px 0;
            transition: color 0.3s ease, border-bottom 0.3s ease, outline 0.2s ease;
            border-bottom: 5px solid transparent !important;
            
            &:focus {
                outline: 2px solid ${({ theme }) => theme.colors.primary.main} !important;
                outline-offset: 2px;
            }
        `,
    },
    menuItemIcon: {
        css: css`
            display: none;
        `,
        size: 18,
        color: "secondary.contrast",
    },
    menuItemTypography: {
        variant: "headerSecondary",
        color: "secondary.contrast",
        css: css`
            font-weight: 600;
            text-transform: capitalize;
            transition: color 0.3s ease;
            cursor: pointer;
            white-space: nowrap;
        `,
    },
    megaMenu: {
        transitionDuration: "short",
        contentBodyProps: {
            css: css`
                padding: 24px;
                border-radius: 8px;
                box-shadow: 0px 4px 8px rgba(0, 0, 0, 0.25);
                overflow: hidden;
                width: auto !important;
                min-width: 180px;
                max-height: none;

                ul {
                    flex-direction: column;
                    margin: 0;

                    li {
                        padding: 0;

                        &:last-child {

                            a {
                                margin-bottom: 0;
                            }
                        }

                        a {

                            &:hover {

                                span {
                                    color: ${({ theme }) => theme.colors.primary.main} !important;
                                }
                            }

                            span {
                                font-size: 16px;
                                font-weight: 300;
                                color: ${({ theme }) => theme.colors.secondary.contrast} !important;
                                white-space: nowrap;
                            }
                        }
                    }
                }
            `,
        },
    },
    megaMenuGridContainer: {
        css: css`
            margin: 0;
        `,
    },
    cascadingMenu: {
        cssOverrides: {
            wrapper: css`
                position: inherit;

                & > ul {
                    width: 1024px;
                    height: 600px;
                    left: 0%;
                    border-radius: 8px;
                    padding: 32px;
                    overflow-y: auto;

                    & > li {
                        width: 296px;
                        padding-right: 32px;

                        &:hover {
                        
                            & > a {
                                border-bottom: 1px solid ${({ theme }) => theme.colors.primary.main};

                                span {
                                    color: ${({ theme }) => theme.colors.primary.main};
                                }
                            }
                        }

                        & > a {
                            border-bottom: 1px solid ${({ theme }) => theme.colors.secondary.contrast};

                            & > span {
                                font-size: 16px;
                                font-weight: 600;
                                padding: 16px 0;

                                &:last-child {

                                    &:not(:only-child) {
                                        display: none;
                                    }
                                }
                            }
                        }

                        &:hover > ul,
                        &:focus-within > ul,
                        &.focus-within > ul {
                            display: flex !important;
                            flex-direction: column;
                            flex-wrap: wrap;
                            align-content: flex-start;
                            left: 328px !important;
                        }
                    }
                }
            `,
            menuItem: css`
                position: static;
                width: 241px;

                a {
                    transition: outline 0.2s ease;
                    position: relative;

                    &:focus,
                    &:focus-visible {
                        outline: 2px solid ${({ theme }) => theme.colors.primary.main} !important;
                        outline-offset: -2px;
                    }

                    &:hover{
                        background-color: transparent;

                        span {
                            color: ${({ theme }) => theme.colors.primary.main};
                        }
                    }
                }

                ul {
                    box-shadow: none;
                    width: 273px;
                    height: calc(100% - 32px);
                    top: 32px !important;

                    li {
                        width: 273px;
                        margin-bottom: 8px;

                        &:hover {

                            & > a {
                                background-color: transparent;

                                span{
                                    color: ${({ theme }) => theme.colors.primary.main};
                                    font-weight: 600;
                                    text-decoration: underline;
                                }
                            }                        
                        }

                        a {
                            display: flex;
                            gap: 4px;
                            width: 241px;
                            min-height: 0;

                            span {
                                font-size: 16px;
                                padding: 0;
                            }

                            & > span {
                            
                                &:last-child {
                                    position: static;
                                }
                            }
                        }
                    }

                    ul{
                        width: 209px;
                        left: 273px !important;
                        top: 0 !important;

                        li {
                            width: auto;

                            @media (max-width: 992px) {
                                width: 55%;
                            }
                        }
                    }
                }
            `,
        },
    },
    mobileSearchButton: {
        size: 48,
        buttonType: "solid",
        color: "secondary",
        css: css`
            padding: 0 10px;
            background-color: transparent;
            border: none;
        `,
    },
    mobileWrapper: {
        css: css`
            display: flex;
            justify-content: space-between;
        `,
    },
    compactFlyoutMenu: {
        css: css`
            & button {
                background: transparent;
                border: none;
                &:hover {
                    background: rgba(0, 0, 0, 0.3);
                }

                svg {
                    color: ${props => resolveColor(props.theme.header.linkColor, props.theme)};
                }
            }
        `,
    },
    mobileSearchWrapper: {
        css: css`
            text-align: right;
        `,
    },
    mobileMenuWrapper: {
        css: css`
            text-align: right;
        `,
    },
    mobileSearchInputWrapper: {
        css: css`
            display: flex;
            align-items: center;
        `,
    },
    mobileSearchInputStyles: {
        input: {
            cssOverrides: {
                formField: css`
                    width: 100%;
                `,
            },
        },
        popover: {
            wrapperProps: {
                css: css`
                    width: calc(100% - 45px);
                `,
            },
        },
        popoverContentBody: {
            as: "div",
            _height: "100%",
            css: css`
                box-shadow: none;
            `,
        },
        autocompleteWrapper: {
            css: css`
                display: flex;
                flex-direction: column;
            `,
        },
        autocompleteColumnWrapper: {
            css: css`
                display: flex;
                flex-direction: column;
                width: 100%;
                padding: 0 50px 0 30px;
            `,
        },
        searchHistoryStyles: {
            wrapper: {
                css: css`
                    display: flex;
                    flex-direction: column;
                    width: 100%;
                    padding: 0 50px 15px 30px;
                `,
            },
        },
        autocompleteProductsStyles: {
            titleLink: {
                css: css`
                    width: 100%;
                `,
            },
            erpNumberText: {
                css: css`
                    width: 100%;
                    text-align: left;
                    margin: 5px 0 0 0;
                `,
            },
        },
    },
    mobileSearchModalCloseIcon: {
        src: X,
        size: 18,
        css: css`
            margin-left: 10px;
        `,
    },
};

const defaultCustomCss = `.mobile-wrapper {
}

.mobile-menu-wrapper {
}

.menu-trigger-button {
}

.menu-trigger-button-icon {
}

.drawer {
}

.drawer-section-wrapper {
}

.currency-selector-wrapper {
}

.language-selector-wrapper {
}

.panel-menu {
}

.main-navigation-row {
}

.panel-section-wrapper {
}

.main-navigation-row-icon {
}

.user-row-text {
}

.punch-out-navigation-row-icon {
}

.punch-out-user-row-text {
}

.main-navigation-row-text {
}

.logo-links-row {
}

.logo-link-title {
}

.language-image {
}

.menu-row-icon {
}

.change-customer-row {
}

.change-customer-row-container {
}

.fulfillment-method-grid-item {
}

.addresses-grid-item {
}

.pick-up-address-grid-item {
}

.apply-button-grid-item {
}

.sign-out-row {
}

.sign-out-row-text {
}

.mobile-search-wrapper {
}

.mobile-search-button {
}

.mobile-search-button-icon {
}

.container {
}

.item-wrapper {
}

.cascading-menu {
}

.menu-item {
}

.mega-menu {
}

.mega-menu-grid-container {
}

.mega-menu-grid-item {
}

.mega-menu-heading-link {
}

.mega-menu-link {
}

.quick-order-item-wrapper {
}

.quick-order-link {
}

.vmi-page-link {
}

.mobile-search-modal {
}`;

export class MainNavigation extends React.Component<Props, State> {
    container = React.createRef<HTMLDivElement | null>();
    mobileSearchInput = React.createRef<HTMLInputElement>();
    declare context: React.ContextType<typeof StylesContext>;

    constructor(props: Props) {
        super(props);

        this.state = {
            mobileSearchModalIsOpen: false,
        };
    }

    UNSAFE_componentWillMount(): void {
        this.loadCategoriesIfNeeded();

        setMainNavigation({
            close: () => {
                this.setState({
                    selectedLinkIndex: undefined,
                });
            },
            openMenu: (index: number) => {
                this.setState({
                    selectedLinkIndex: index,
                });
            },
        });
    }

    componentDidUpdate(prevProps: Readonly<Props>): void {
        if (!isEqual(this.props.categoryIdsToLoad, prevProps.categoryIdsToLoad)) {
            this.loadCategoriesIfNeeded(true);
        }
    }

    loadCategoriesIfNeeded(isComponentDidUpdate = false) {
        const { categoryIdsToLoad } = this.props;
        for (const categoryId of Object.keys(categoryIdsToLoad)) {
            if (!this.props.categoryErrorStatusCodeById?.[categoryId]) {
                const maxDepth = categoryIdsToLoad[categoryId];
                if (!this.props.categoryIdsCalled?.includes(categoryId) || isComponentDidUpdate) {
                    this.props.loadCategories(getParameter(categoryId, maxDepth));
                }
            }
        }
    }

    getMobileSearchAutocompletePosition = (element: React.RefObject<HTMLUListElement | null>) => {
        const positionStyle: PositionStyle = {
            position: "fixed",
        };

        if (element.current) {
            const rect = element.current.getBoundingClientRect();
            positionStyle.top = rect.top + rect.height;
            positionStyle.left = 0;
            positionStyle.width = `${document.documentElement.clientWidth}px`;
            positionStyle.height = `${document.documentElement.clientHeight - positionStyle.top}px`;
        }

        return positionStyle;
    };

    mobileSearchButtonClickHandler = () => {
        this.setState({ mobileSearchModalIsOpen: true }, () => {
            setTimeout(() => {
                if (this.mobileSearchInput?.current) {
                    this.mobileSearchInput.current.focus();
                    this.mobileSearchInput.current.click();
                }
            }, 250);
        });
    };

    mobileSearchModalCloseHandler = () => {
        this.setState({ mobileSearchModalIsOpen: false });
    };

    render() {
        const {
            links,
            quickOrderLink,
            fields: {
                showQuickOrder,
                openParentPages,
                customCSS,
                technicalSupportTitle,
                technicalSupportLinks,
                technicalSupportFootnote1,
                technicalSupportFootnote2,
                technicalSupportButtonText,
                technicalSupportRegistrationUrl,
                technicalSupportMembershipCheckText,
                technicalSupportMembershipCheckUrl,
            },
            id,
            allowQuickOrder,
            isCompactHeaderFlyoutMenu,
            flyoutCustomCSS,
            showFlyoutPricingToggle,
            showFlyoutInventoryToggle,
            isCompactHeaderMainNavigation,
            сompactHeaderMainNavigationCustomCSS,
            vmiPageLinks,
            displayVmiNavigation,
            displayModeSwitch,
            currentMode,
        } = this.props;
        const { selectedLinkIndex } = this.state;

        const showQuickOrderLink = showQuickOrder && allowQuickOrder;
        const mainNavContextStyles = this?.context?.styles?.mainNavigation ?? {};
        const styles = mergeToNew(mainNavigationStyles, mainNavContextStyles);

        if (isCompactHeaderFlyoutMenu) {
            const flyoutCustomCssWrapper = {
                css: css`
                    ${flyoutCustomCSS}
                `,
            };

            return (
                <StyledWrapper {...flyoutCustomCssWrapper}>
                    <StyledWrapper className="flyout-menu-wrapper" {...styles.compactFlyoutMenu}>
                        <NavigationDrawer
                            links={links}
                            showQuickOrder={showQuickOrderLink}
                            quickOrderLink={quickOrderLink}
                            displayVmiNavigation={displayVmiNavigation}
                            vmiPageLinks={vmiPageLinks}
                            displayModeSwitch={displayModeSwitch}
                            currentMode={currentMode}
                            isCompactHeaderFlyout={true}
                            showFlyoutPricingToggle={showFlyoutPricingToggle}
                            showFlyoutInventoryToggle={showFlyoutInventoryToggle}
                            allowOpenParentLinks={openParentPages}
                            technicalSupportTitle={technicalSupportTitle}
                            technicalSupportLinks={technicalSupportLinks}
                            technicalSupportFootnote1={technicalSupportFootnote1}
                            technicalSupportFootnote2={technicalSupportFootnote2}
                            technicalSupportButtonText={technicalSupportButtonText}
                            technicalSupportRegistrationUrl={technicalSupportRegistrationUrl}
                            technicalSupportMembershipCheckText={technicalSupportMembershipCheckText}
                            technicalSupportMembershipCheckUrl={technicalSupportMembershipCheckUrl}
                        />
                    </StyledWrapper>
                </StyledWrapper>
            );
        }

        if (isCompactHeaderMainNavigation) {
            const mainNavigationCustomCSSWrapper = {
                css: css`
                    ${сompactHeaderMainNavigationCustomCSS}
                `,
            };

            return (
                <StyledWrapper {...mainNavigationCustomCSSWrapper}>
                    {displayVmiNavigation && (
                        <StyledWrapper className="container" {...styles.container} ref={this.container}>
                            <StyledWrapper className="item-wrapper" {...styles.itemWrapper}>
                                {vmiPageLinks.map(
                                    link =>
                                        link && (
                                            <Link
                                                className="vmi-page-link"
                                                key={link.id}
                                                typographyProps={styles.menuItemTypography}
                                                color={styles.menuItemTypography?.color}
                                                {...styles.menuItem}
                                                id={link.id}
                                                href={link.url}
                                            >
                                                {link.title}
                                            </Link>
                                        ),
                                )}
                            </StyledWrapper>
                        </StyledWrapper>
                    )}
                    {!displayVmiNavigation && (
                        <StyledWrapper className="container" {...styles.container} ref={this.container}>
                            {links.map((link, index) => {
                                return (
                                    // eslint-disable-next-line react/no-array-index-key
                                    <StyledWrapper className="item-wrapper" {...styles.itemWrapper} key={index}>
                                        <MainNavigationItem
                                            index={index}
                                            link={link}
                                            styles={styles}
                                            container={this.container}
                                            isOpen={index === selectedLinkIndex}
                                            displayChangeCustomerLink={this.props.displayChangeCustomerLink}
                                            technicalSupportTitle={technicalSupportTitle}
                                            technicalSupportLinks={technicalSupportLinks}
                                            technicalSupportFootnote1={technicalSupportFootnote1}
                                            technicalSupportFootnote2={technicalSupportFootnote2}
                                            technicalSupportButtonText={technicalSupportButtonText}
                                            technicalSupportRegistrationUrl={technicalSupportRegistrationUrl}
                                            technicalSupportMembershipCheckText={technicalSupportMembershipCheckText}
                                            technicalSupportMembershipCheckUrl={technicalSupportMembershipCheckUrl}
                                        />
                                    </StyledWrapper>
                                );
                            })}
                            {showQuickOrderLink && quickOrderLink && (
                                <StyledWrapper className="item-wrapper" {...styles.itemWrapper}>
                                    <StyledWrapper
                                        className="quick-order-item-wrapper"
                                        {...styles.quickOrderItemWrapper}
                                    >
                                        <Link
                                            className="quick-order-link"
                                            typographyProps={styles.menuItemTypography}
                                            color={styles.menuItemTypography?.color}
                                            {...styles.menuItem}
                                            id="quickOrder"
                                            href={quickOrderLink.url}
                                        >
                                            {quickOrderLink.title}
                                        </Link>
                                    </StyledWrapper>
                                </StyledWrapper>
                            )}
                        </StyledWrapper>
                    )}
                </StyledWrapper>
            );
        }

        const customCssWrapper = {
            css: css`
                ${customCSS}
            `,
        };

        return (
            <StyledWrapper {...customCssWrapper}>
                <StyledWrapper className="mobile-wrapper" {...styles.mobileWrapper}>
                    <Hidden className="mobile-menu-wrapper" above="md" {...styles.mobileMenuWrapper}>
                        <NavigationDrawer
                            links={links}
                            showQuickOrder={showQuickOrderLink}
                            quickOrderLink={quickOrderLink}
                            displayVmiNavigation={displayVmiNavigation}
                            vmiPageLinks={vmiPageLinks}
                            displayModeSwitch={displayModeSwitch}
                            currentMode={currentMode}
                            rootElementSelector=".mobile-menu-wrapper"
                            allowOpenParentLinks={openParentPages}
                            technicalSupportTitle={technicalSupportTitle}
                            technicalSupportLinks={technicalSupportLinks}
                            technicalSupportFootnote1={technicalSupportFootnote1}
                            technicalSupportFootnote2={technicalSupportFootnote2}
                            technicalSupportButtonText={technicalSupportButtonText}
                            technicalSupportRegistrationUrl={technicalSupportRegistrationUrl}
                            technicalSupportMembershipCheckText={technicalSupportMembershipCheckText}
                            technicalSupportMembershipCheckUrl={technicalSupportMembershipCheckUrl}
                        />
                    </Hidden>
                    <Hidden className="mobile-search-wrapper" above="sm" {...styles.mobileSearchWrapper}>
                        <Button
                            className="mobile-search-button"
                            {...styles.mobileSearchButton}
                            onClick={this.mobileSearchButtonClickHandler}
                        >
                            <ButtonIcon className="mobile-search-button-icon" src={Search} />
                            <VisuallyHidden>{translate("Search")}</VisuallyHidden>
                        </Button>
                    </Hidden>
                </StyledWrapper>
                <Hidden below="lg">
                    {!displayVmiNavigation && (
                        <StyledWrapper className="container" {...styles.container} ref={this.container}>
                            {links.map((link, index) => {
                                return (
                                    // eslint-disable-next-line react/no-array-index-key
                                    <StyledWrapper className="item-wrapper" {...styles.itemWrapper} key={index}>
                                        <MainNavigationItem
                                            index={index}
                                            link={link}
                                            styles={styles}
                                            container={this.container}
                                            isOpen={index === selectedLinkIndex}
                                            displayChangeCustomerLink={this.props.displayChangeCustomerLink}
                                            technicalSupportTitle={technicalSupportTitle}
                                            technicalSupportLinks={technicalSupportLinks}
                                            technicalSupportFootnote1={technicalSupportFootnote1}
                                            technicalSupportFootnote2={technicalSupportFootnote2}
                                            technicalSupportButtonText={technicalSupportButtonText}
                                            technicalSupportRegistrationUrl={technicalSupportRegistrationUrl}
                                            technicalSupportMembershipCheckText={technicalSupportMembershipCheckText}
                                            technicalSupportMembershipCheckUrl={technicalSupportMembershipCheckUrl}
                                        />
                                    </StyledWrapper>
                                );
                            })}
                            {showQuickOrderLink && quickOrderLink && (
                                <StyledWrapper className="item-wrapper" {...styles.itemWrapper}>
                                    <StyledWrapper
                                        className="quick-order-item-wrapper"
                                        {...styles.quickOrderItemWrapper}
                                    >
                                        <Link
                                            className="quick-order-link"
                                            typographyProps={styles.menuItemTypography}
                                            color={styles.menuItemTypography?.color}
                                            {...styles.menuItem}
                                            id="quickOrder"
                                            href={quickOrderLink.url}
                                        >
                                            {quickOrderLink.title}
                                        </Link>
                                    </StyledWrapper>
                                </StyledWrapper>
                            )}
                        </StyledWrapper>
                    )}
                    {displayVmiNavigation && (
                        <StyledWrapper className="container" {...styles.container} ref={this.container}>
                            <StyledWrapper className="item-wrapper" {...styles.itemWrapper}>
                                {vmiPageLinks.map(
                                    link =>
                                        link && (
                                            <Link
                                                className="vmi-page-link"
                                                key={link.id}
                                                typographyProps={styles.menuItemTypography}
                                                color={styles.menuItemTypography?.color}
                                                {...styles.menuItem}
                                                id={link.id}
                                                href={link.url}
                                            >
                                                {link.title}
                                            </Link>
                                        ),
                                )}
                            </StyledWrapper>
                        </StyledWrapper>
                    )}
                </Hidden>
                <Modal
                    className="mobile-search-modal"
                    {...styles.mobileSearchModal}
                    isOpen={this.state.mobileSearchModalIsOpen}
                    closeOnEsc={true}
                    handleClose={this.mobileSearchModalCloseHandler}
                    headline={
                        <SearchInput
                            id={id}
                            inputRef={this.mobileSearchInput}
                            autocompletePositionFunction={this.getMobileSearchAutocompletePosition}
                            onBeforeGoToUrl={this.mobileSearchModalCloseHandler}
                            extendedStyles={styles.mobileSearchInputStyles}
                        />
                    }
                />
            </StyledWrapper>
        );
    }
}

MainNavigation.contextType = StylesContext;

const basicTab = {
    displayName: "Basic",
    sortOrder: 0,
};

const techSupportTab = {
    displayName: "Technical Support Tools",
    sortOrder: 1,
};

const advancedTab = {
    displayName: "Advanced",
    sortOrder: 2,
};

const mainNavigation: WidgetModule = {
    component: connect(mapStateToProps, mapDispatchToProps)(MainNavigation),
    definition: {
        group: "Header",
        icon: "magnifying-glass",
        allowedContexts: ["Header"],
        fieldDefinitions: [
            {
                name: fields.links,
                editorTemplate: "ListField",
                onEditRow: (index: number, dispatch) => {
                    dispatch({
                        type: "SendToSite/OpenMainNavigation",
                        index,
                    });
                },
                onDoneEditingRow: dispatch => {
                    dispatch({
                        type: "SendToSite/CloseMainNavigation",
                    });
                },
                onLoad: dispatch => {
                    dispatch({
                        type: "SendToSite/CloseMainNavigation",
                    });
                },
                getDisplay: (item: HasFields, state) => {
                    const { type: typeValue, value: destinationValue } = item.fields.destination;
                    const { overrideTitle, title, linkType, parentTitle, titleLink } = item.fields;
                    let value = destinationValue;
                    let type = typeValue;
                    if (linkType === MAIN_NAVIGATION_LINK_TYPE.CustomLinkList) {
                        if (parentTitle) {
                            return parentTitle;
                        }
                        type = titleLink.type;
                        value = titleLink.value;
                    }
                    if (type === MAIN_NAVIGATION_DESTINATION_TYPE.Page) {
                        const link = getPageLinkByNodeId(state, value);
                        return overrideTitle || link?.title;
                    }
                    if (type === MAIN_NAVIGATION_DESTINATION_TYPE.Category) {
                        if (overrideTitle) {
                            return overrideTitle;
                        }
                        if (value === emptyGuid) {
                            return "Products";
                        }
                        const categoryState = getCategoryState(state, value);
                        if (!categoryState.value) {
                            if (!categoryState.isLoading && value) {
                                return dispatch => {
                                    dispatch(
                                        loadCategory({
                                            id: value,
                                        }),
                                    );
                                };
                            }
                            return "";
                        }
                        return categoryState.value.shortDescription;
                    }
                    if (type === MAIN_NAVIGATION_DESTINATION_TYPE.Url) {
                        return title ?? value;
                    }
                    return value;
                },
                defaultValue: [],
                fieldType: "Translatable",
                fieldDefinitions: [
                    {
                        name: "linkType",
                        editorTemplate: "RadioButtonsField",
                        defaultValue: "Link",
                        isRequired: true,
                        options: [
                            {
                                displayName: "Link",
                                value: MAIN_NAVIGATION_LINK_TYPE.Link,
                            },
                            {
                                displayName: "Mega Menu",
                                value: MAIN_NAVIGATION_LINK_TYPE.MegaMenu,
                            },
                            {
                                displayName: "Cascading Menu",
                                value: MAIN_NAVIGATION_LINK_TYPE.CascadingMenu,
                            },
                            {
                                displayName: "Custom Link List",
                                value: MAIN_NAVIGATION_LINK_TYPE.CustomLinkList,
                            },
                        ],
                    },
                    {
                        name: "overrideTitle",
                        editorTemplate: "TextField",
                        defaultValue: "",
                        isVisible: item =>
                            item.fields.destination.type !== MAIN_NAVIGATION_DESTINATION_TYPE.Url &&
                            item.fields.linkType !== MAIN_NAVIGATION_LINK_TYPE.CustomLinkList,
                    },
                    {
                        name: "destination",
                        editorTemplate: "LinkField",
                        defaultValue: {
                            value: "",
                            type: MAIN_NAVIGATION_DESTINATION_TYPE.Page,
                        },
                        isRequired: true,
                        allowUrls: item => item.fields.linkType === MAIN_NAVIGATION_LINK_TYPE.Link,
                        showCategoryRoot: item => true,
                        isVisible: item => item.fields.linkType !== MAIN_NAVIGATION_LINK_TYPE.CustomLinkList,
                    },
                    {
                        name: "title",
                        editorTemplate: "TextField",
                        defaultValue: "",
                        isVisible: item => item.fields.destination.type === MAIN_NAVIGATION_DESTINATION_TYPE.Url,
                    },
                    {
                        name: "parentTitle",
                        displayName: "Title",
                        editorTemplate: "TextField",
                        defaultValue: "",
                        isVisible: item => item.fields.linkType === MAIN_NAVIGATION_LINK_TYPE.CustomLinkList,
                        validate: (value, item) => {
                            if (!value && item.fields.titleLink.value === "") {
                                return TS("Either Title or Destination must have a value");
                            }

                            if (!value && item.fields.titleLink.type === MAIN_NAVIGATION_DESTINATION_TYPE.Url) {
                                return TS("URLs must have a corresponding title");
                            }

                            return null;
                        },
                    },
                    {
                        name: "titleLink",
                        displayName: "Destination",
                        editorTemplate: "LinkField",
                        defaultValue: { type: MAIN_NAVIGATION_DESTINATION_TYPE.Page, value: "" },
                        isVisible: item => item.fields.linkType === MAIN_NAVIGATION_LINK_TYPE.CustomLinkList,
                    },
                    {
                        name: "childLinks",
                        editorTemplate: "ListField",
                        getDisplay: (item: HasFields, state) => {
                            const {
                                destination: { type, value },
                                overrideTitle,
                            } = item.fields;
                            if (overrideTitle) {
                                return overrideTitle;
                            }
                            if (type === MAIN_NAVIGATION_DESTINATION_TYPE.Page) {
                                const link = getPageLinkByNodeId(state, value);
                                return link?.title;
                            }
                            if (type === MAIN_NAVIGATION_DESTINATION_TYPE.Category) {
                                let displayValue = "";
                                const categories = (state as any).pageEditor.categories;
                                if (!categories) {
                                    displayValue = "Loading...";
                                } else {
                                    const matchingCategories = categories.filter((o: { id: string }) => o.id === value);
                                    if (matchingCategories.length === 0) {
                                        displayValue = "Unknown";
                                    } else {
                                        displayValue = matchingCategories[0].shortDescription;
                                    }
                                }

                                return displayValue;
                            }
                            if (type === MAIN_NAVIGATION_DESTINATION_TYPE.Url) {
                                return value;
                            }
                            return value;
                        },
                        defaultValue: [],
                        fieldDefinitions: [
                            {
                                name: "destination",
                                editorTemplate: "LinkField",
                                defaultValue: {
                                    value: "",
                                    type: MAIN_NAVIGATION_DESTINATION_TYPE.Page,
                                },
                                isRequired: true,
                            },
                            {
                                name: "overrideTitle",
                                editorTemplate: "TextField",
                                defaultValue: "",
                            },
                            {
                                name: "openInNewWindow",
                                editorTemplate: "CheckboxField",
                                defaultValue: false,
                            },
                        ],
                        isVisible: item => item.fields.linkType === MAIN_NAVIGATION_LINK_TYPE.CustomLinkList,
                    },
                    {
                        name: "numberOfColumns",
                        editorTemplate: "DropDownField",
                        defaultValue: 6,
                        options: [{ value: 2 }, { value: 3 }, { value: 4 }, { value: 6 }],
                        isRequired: true,
                        isVisible: (item: HasFields) => item.fields.linkType === MAIN_NAVIGATION_LINK_TYPE.MegaMenu,
                    },
                    {
                        name: "maxDepth",
                        editorTemplate: "DropDownField",
                        defaultValue: 3,
                        options: [{ value: 1 }, { value: 2 }, { value: 3 }, { value: 4 }],
                        isRequired: true,
                        isVisible: (item: HasFields) =>
                            item.fields.linkType === MAIN_NAVIGATION_LINK_TYPE.CascadingMenu,
                    },
                    {
                        name: "excludedCategories",
                        displayName: "Excluded Categories",
                        editorTemplate: "CategoriesField",
                        defaultValue: [],
                        tooltip: "Select categories to exclude from this menu.",
                        isVisible: (item: HasFields) =>
                            item.fields.destination?.type === MAIN_NAVIGATION_DESTINATION_TYPE.Category &&
                            item.fields.destination?.value === emptyGuid &&
                            (item.fields.linkType === MAIN_NAVIGATION_LINK_TYPE.MegaMenu ||
                                item.fields.linkType === MAIN_NAVIGATION_LINK_TYPE.CascadingMenu),
                    },
                    {
                        name: "openInNewWindow",
                        editorTemplate: "CheckboxField",
                        defaultValue: false,
                        isVisible: (item: HasFields) => item.fields.linkType === MAIN_NAVIGATION_LINK_TYPE.Link,
                    },
                ],
                tab: basicTab,
            },
            {
                name: fields.showQuickOrder,
                editorTemplate: "CheckboxField",
                defaultValue: true,
                fieldType: "General",
                tab: basicTab,
            },
            {
                name: fields.openParentPages,
                displayName: "Open Parent Pages",
                tooltip:
                    "When enabled, tapping on a text link in the flyout menu will directly open the linked webpage and require users to click the chevron to access child pages. If disabled, tapping any link in the flyout menu will navigate to a submenu of child pages.",
                editorTemplate: "CheckboxField",
                defaultValue: false,
                fieldType: "General",
                tab: basicTab,
            },
            {
                fieldType: "Translatable",
                name: fields.technicalSupportTitle,
                displayName: "Section Title",
                editorTemplate: "TextField",
                defaultValue: DEFAULT_TECH_SUPPORT_TITLE,
                tab: techSupportTab,
            },
            {
                fieldType: "Translatable",
                name: fields.technicalSupportLinks,
                displayName: "Links",
                editorTemplate: "ListField",
                getDisplay: ({ fields: { title } }: HasFields) => title || "Link",
                defaultValue: DEFAULT_TECH_SUPPORT_LINKS,
                tab: techSupportTab,
                fieldDefinitions: [
                    {
                        name: "title",
                        displayName: "Title",
                        editorTemplate: "TextField",
                        defaultValue: "",
                        isRequired: true,
                    },
                    {
                        name: "url",
                        displayName: "URL",
                        editorTemplate: "TextField",
                        defaultValue: "",
                        isRequired: true,
                    },
                    {
                        name: "openInNewWindow",
                        displayName: "Open in New Window",
                        editorTemplate: "CheckboxField",
                        defaultValue: true,
                    },
                ],
            },
            {
                fieldType: "Translatable",
                name: fields.technicalSupportFootnote1,
                displayName: "Footnote Line 1",
                editorTemplate: "TextField",
                defaultValue: DEFAULT_TECH_SUPPORT_FOOTNOTE_1,
                tab: techSupportTab,
            },
            {
                fieldType: "Translatable",
                name: fields.technicalSupportFootnote2,
                displayName: "Footnote Line 2",
                editorTemplate: "TextField",
                defaultValue: DEFAULT_TECH_SUPPORT_FOOTNOTE_2,
                tab: techSupportTab,
            },
            {
                fieldType: "Translatable",
                name: fields.technicalSupportButtonText,
                displayName: "Member Button Text",
                editorTemplate: "TextField",
                defaultValue: DEFAULT_TECH_SUPPORT_BUTTON_TEXT,
                tab: techSupportTab,
            },
            {
                fieldType: "General",
                name: fields.technicalSupportRegistrationUrl,
                displayName: "Member Registration URL",
                editorTemplate: "TextField",
                defaultValue: DEFAULT_TECH_SUPPORT_REGISTRATION_URL,
                tab: techSupportTab,
            },
            {
                fieldType: "Translatable",
                name: fields.technicalSupportMembershipCheckText,
                displayName: "Membership Check Button Text",
                editorTemplate: "TextField",
                defaultValue: DEFAULT_TECH_SUPPORT_MEMBERSHIP_CHECK_TEXT,
                tab: techSupportTab,
            },
            {
                fieldType: "General",
                name: fields.technicalSupportMembershipCheckUrl,
                displayName: "Membership Check URL",
                editorTemplate: "TextField",
                defaultValue: DEFAULT_TECH_SUPPORT_MEMBERSHIP_CHECK_URL,
                tab: techSupportTab,
            },
            {
                name: fields.customCSS,
                displayName: "Custom CSS",
                editorTemplate: "CodeField",
                fieldType: "General",
                tab: advancedTab,
                defaultValue: defaultCustomCss,
                isVisible: (item, shouldDisplayAdvancedFeatures) => !!shouldDisplayAdvancedFeatures,
                validate: value => {
                    if (value === undefined || value === null) {
                        return "";
                    }

                    const result = cssLinter.parse(value, { silent: true });
                    if (result?.stylesheet?.parsingErrors) {
                        // the error output at this time only has room for one line so we just show the first error
                        return result.stylesheet.parsingErrors.length <= 0
                            ? ""
                            : result.stylesheet.parsingErrors.map(error => `${error.reason} on line ${error.line}`)[0];
                    }

                    return "Unable to parse Css";
                },
                options: {
                    mode: "css",
                    lint: true,
                    autoRefresh: true,
                },
            },
        ],
    },
};

export default mainNavigation;
